import LoadingState from '../../../values/loading-state-enum'
import {type GuidType} from '../../../values/generic-type-defintions'
import {type OTAssetRow} from '../../../pages/ot-inventory/contexts/types/ot-types'
import {type OTAssetRowValidation} from '../../../pages/ot-inventory/components/asset-upload/steps/data-review-step'
import {type ColumnsMapping} from '../../../pages/ot-inventory/components/asset-upload/hook/use-asset-upload'

export enum OTAssetLifecycleStatusEnum {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    DECOMMISSIONED = 'decommissioned',
    COLD_SPARE = 'cold_spare',
    HOT_SPARE = 'hot_spare',
}

export const AssetStatusToLabelMap: Record<OTAssetStatusType, string> = {
    active: 'Active',
    inactive: 'Inactive',
    decommissioned: 'Decommissioned',
    cold_spare: 'Cold Spare',
    hot_spare: 'Hot Spare',
}

type OTAssetStatusType = `${OTAssetLifecycleStatusEnum}`

interface OTAssetCustomField {
    name: string
    value: string
}

/**
 * Enum keys for GET/POST for asset list.
 */
export enum OTAssetKeyEnum {
    SYSTEM = 'systemID',
    NAME = 'name',
}

export interface OTAsset {
    id: string
    assetTypeID: string
    name: string
    vendor: string
    status: OTAssetLifecycleStatusEnum
    zoneID: string
    systemID: string
    locationID: string
    revision: number
    createdAt: string
    updatedAt: string
    model: string
    description: string
    softwareVersion: string
    communicationProtocolID: string
    softwareID: string
    systemName: string
    assetTypeName: string
    owner: GuidType
    zoneName: string
    communicationProtocolName: string
    softwareName: string
    physicalInterfaces: PhysicalInterface[]
    networkInterface: NetworkInterface
    customFields: OTAssetCustomField[]
}

interface PhysicalInterface {
    id: string
    name: string
    created_at: string
    updated_at: string
}

export interface CreateOTAssetReq {
    assetTypeID: GuidType
    name: string
    vendor: string
    model: string
    zoneID: GuidType
    systemID: GuidType
    locationID?: GuidType
    owner?: GuidType
    description: string
    physicalInterfaceIDs: GuidType[]
    softwareID: GuidType
    softwareVersion: string
    communicationProtocolID: string
    status: OTAssetLifecycleStatusEnum
    revision: number
    customFields: OTAssetCustomField[]
    networkInterface?: NetworkInterface
    source: 'otInventory' | 'networkInventory'
}

export interface NetworkInterface {
    id?: string
    ipAddress: string
    macAddress: string
}

export interface DataReview {
    validationResult: OTAssetRowValidation[]
    duplicateAssetsInFile: Record<string, string[]>
    duplicateAssetsInDb: Record<string, string[]>
}

export interface ColumnMappingStep {
    columnsMapping: ColumnsMapping
}

export interface BulkUpload {
    assets: OTAssetRow[]
    dataReview: DataReview
    columnMapping: ColumnMappingStep
}

export interface OTAssetStateReduxState {
    loadingState: LoadingState
    locationID: string
    assets: OTAsset[]
    openedModal: boolean
    selectedModalAsset?: OTAsset
    deleteAssetIsLoading: boolean
    deleteAssetError: string
    cortexSuggestion: Partial<OTAssetRow[]>
    bulkUpload: BulkUpload
}

export const DEFAULT_OTASSETS_STATE: OTAssetStateReduxState = {
    loadingState: LoadingState.NotPopulated,
    locationID: '',
    assets: [],
    openedModal: false,
    deleteAssetIsLoading: false,
    deleteAssetError: '',
    cortexSuggestion: [],
    bulkUpload: {
        assets: [],
        columnMapping: {
            // Hack cause there is cyclic dependency error when trying to
            // use OTAssetKeys, Try printing it in console.log
            columnsMapping: {} as ColumnsMapping,
        },
        dataReview: {
            validationResult: [],
            duplicateAssetsInFile: {},
            duplicateAssetsInDb: {},
        },
    },
}

export interface UpdateBulkUploadAssetPayload {
    rowIndex: number
    columnId: string
    value: string
}
